<template>
  <!-- <div class="d-flex align-items-center"> -->
  <nav id="navmenu" class="navmenu" style="margin-right: 30px">
    <ul style="cursor: pointer">
      <li v-for="item in menu" :key="item.id" class="dropdown">
        <a @click="openMenu(item)">
          <span>{{ item.titulo }}</span>
          <i
            v-if="item.menu.length"
            class="bi bi-chevron-down toggle-dropdown"
          ></i>
        </a>
        <ul v-if="item.menu.length">
          <li v-for="subItem in item.menu" :key="subItem.id" class="dropdown">
            <a @click="openMenu(subItem)">
              <span>{{ subItem.titulo }}</span>
              <i
                v-if="subItem.menu.length"
                class="bi bi-chevron-down toggle-dropdown"
              ></i>
            </a>
          </li>
        </ul>
      </li>
    </ul>
    <!-- <i class="mobile-nav-toggle d-xl-none bi bi-list"></i> -->
  </nav>

  <!-- <span
    style="cursor: pointer"
    class="btn-register btn btn-register"
    @click="openRegister()"
    >Cadastre-se</span
  > -->

  <a style="cursor: pointer" class="btn-getstarted" @click="openRegister()"
    >Cadastrar</a
  >

  <a style="cursor: pointer" class="btn-getstarted" @click="openLogin()"
    >Entrar</a
  >
  <!-- </div> -->
</template>

<script>
import { onMounted, reactive, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { MenuService } from "./menu.service";

export default {
  name: "ComponentMenu",
  setup() {
    const $serviceMenu = new MenuService();
    const $router = useRouter();

    const data = reactive({
      menu: ref([]),
    });

    onMounted(async () => {
      findMenu();
    });

    async function findMenu() {
      const response = await $serviceMenu.findMenu();
      data.menu = response;
    }

    function openMenu(item) {
      if (item.link) {
        window.open(item.link);
        return;
      }
      if (item.pageName) {
        $router.push({
          name: item.pageName,
          params: { pageId: item.pageId },
        });
      }
    }

    function openLogin() {
      $serviceMenu.openLogin();
    }

    function openRegister() {
      $serviceMenu.openRegister();
    }

    return {
      ...toRefs(data),
      openMenu,
      openLogin,
      openRegister,
    };
  },
};
</script>
